<template>
  <div class="sales-table-item app-table-dropdown__row-body-default">
    <div class="sales-table-item__row-body-content">
      <ul
        class="app-table-dropdown__list app-table-dropdown__row-body-default-item sales-table-item__list"
      >
        <li class="app-table-dropdown__list-item sales-table-item__list-item">
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            Номер заказа
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            {{ response.number }}
          </p>
        </li>
        <li class="app-table-dropdown__list-item sales-table-item__list-item">
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            Покупатель
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            {{ response.contractorName }}
          </p>
        </li>
        <li class="app-table-dropdown__list-item sales-table-item__list-item">
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            Дата
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            {{ response.createdAt | dateFormat() }}
          </p>
        </li>
        <li
          v-if="textForStatus && textForStatus.text"
          class="app-table-dropdown__list-item sales-table-item__list-item"
        >
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            {{ textForStatus.title }}
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            {{ textForStatus.text }}

            <app-tooltip-answer
              v-if="textForStatus.tooltip"
              :tooltip="textForStatus.tooltip"
              isInline
            ></app-tooltip-answer>
          </p>
        </li>
      </ul>
      <ul
        class="app-table-dropdown__list app-table-dropdown__row-body-default-item sales-table-item__list"
      >
        <li class="app-table-dropdown__list-item sales-table-item__list-item">
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            Сумма
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            <span>{{ response.priceTotal | price() }} руб.</span>
            <span class="sales-table-item__old-price" v-if="response.discount"
              >{{ response.priceTotalWithoutDiscount | price() }} руб.</span
            >
          </p>
        </li>
        <li class="app-table-dropdown__list-item sales-table-item__list-item">
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            Объем
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            {{ response.volume.value }} {{ perUnitText(response.volume.unit) }}.
          </p>
        </li>
        <li class="app-table-dropdown__list-item sales-table-item__list-item">
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            Лот
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            <span v-if="response.lotId">№{{ response.lotId }}</span>
            <span v-else>н/д</span>
          </p>
        </li>
        <li class="app-table-dropdown__list-item sales-table-item__list-item">
          <span
            class="app-table-dropdown__list-title sales-table-item__list-row"
          >
            Промокод
          </span>
          <p class="app-table-dropdown__list-text sales-table-item__list-row">
            <span v-if="response.discount">{{
              response.discount.promoCode
            }}</span>
            <span v-else>н/д</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="sales-table-item__row-body-btn-block">
      <app-button-control
        class="app-table-dropdown__btn orders-table__btn"
        type="white"
        size="small"
        :route="`/sales/item/${response.number}`"
      >
        Подробнее о заявке
      </app-button-control>
    </div>
  </div>
</template>

<script>
import {
  informationForStatusOrder,
  perUnitText,
  getDiscountPrice,
} from '@/helpers';

export default {
  name: 'SalesTableItem',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppTooltipAnswer: () => import('@/components/ui/AppTooltipAnswer'),
  },
  props: {
    response: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    /**
     * Информация для статуса
     */
    textForStatus() {
      return this.informationForStatusOrder(this.response);
    },
  },
  methods: { getDiscountPrice, perUnitText, informationForStatusOrder },
};
</script>

<style lang="scss" scoped>
.sales-table-item {
  display: flex;
  flex-direction: column;

  &__old-price {
    font-size: 0.8em;
    font-weight: 300;
    color: #828282;
    text-decoration: line-through;
  }

  &__row-body-content {
    display: flex;
  }

  &__list-item {
    justify-content: space-between;

    @include media-xxs() {
      flex-direction: column;
    }
  }

  &__list-row {
    width: 100%;
  }
}
</style>
